var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"empty_wrap"},[_c('div',{staticClass:"img_box"}),_c('div',{staticClass:"text_box"},[_vm._v(_vm._s(_vm.$t('no_point')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }